import React from 'react';
import './Slogan.css';

const Slogan = () => {
  return (
    <div className="p-10 bg-red-600 text-center">
      <h1 className="text-red-800 slogan-title">WE BELIEVE</h1>
      <p className="text-white slogan-text">
        Ordering custom parts ought to be simple, fast, and straightforward.
      </p>
    </div>
  )
}

export default Slogan;
